"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../hooks");
const react_if_1 = require("react-if");
exports.EmailCanvasCodeModeToggle = () => {
    const { dispatchCanvasAction } = hooks_1.useEmailCanvasUpdate();
    const { prefs: { codeMode }, } = hooks_1.useEmailCanvasContext();
    return (react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarButton, { osysName: "EmailCanvasCodeModeToggle", active: codeMode, className: "text-danger", onClick: () => {
            dispatchCanvasAction({
                data: {
                    codeMode: !codeMode,
                },
                type: 'prefs',
            });
        }, osysIcon: "appAdminsOnly", tooltip: !codeMode ? 'Turn code mode on' : 'Turn code mode off' },
        react_2.default.createElement(react_if_1.When, { condition: !!codeMode },
            react_2.default.createElement("span", { className: "text-muted small text-danger" }, "Coding"))));
};
//# sourceMappingURL=CodeModeToggle.js.map